import BaseModel from 'models/BaseModel';

export default class UserRoleModel extends BaseModel {}
